// Registry of imperative controllers (alphaTab/Tone live here, NOT in React state).
// Created once and shared via context so the cursor loop and components command them directly.
import { createContext, useContext, useRef, type ReactNode } from "react";
import { ScoreController } from "../notation/ScoreController";
import { SongController } from "../audio/SongController";
import { YouTubeController } from "../audio/YouTubeController";
import { CursorLoop } from "../engine/CursorLoop";
import { useProjectStore } from "./projectStore";
import type { PlaybackSource } from "../audio/PlaybackSource";

export class Controllers {
  readonly score = new ScoreController();
  readonly song = new SongController();
  readonly youtube = new YouTubeController();
  readonly cursorLoop: CursorLoop;
  constructor() {
    this.cursorLoop = new CursorLoop(this);
  }
  // the active audio source for "song" playback mode (file/default = Tone.Player; youtube = IFrame)
  activeSource(): PlaybackSource {
    return useProjectStore.getState().source.kind === "youtube" ? this.youtube : this.song;
  }
}

const Ctx = createContext<Controllers | null>(null);

export function ControllersProvider({ children }: { children: ReactNode }) {
  const ref = useRef<Controllers | null>(null);
  if (!ref.current) ref.current = new Controllers();
  return <Ctx.Provider value={ref.current}>{children}</Ctx.Provider>;
}

export function useControllers(): Controllers {
  const c = useContext(Ctx);
  if (!c) throw new Error("useControllers must be used within <ControllersProvider>");
  return c;
}
